export default "__VITE_ASSET__J6zONqNR__"